<template>
  <c-body v-show="dataLoaded">
    <header class="toolbar">
      <div class="l-container">
        <div class="toolbar__group">
          <c-level>
            <template slot="left">
              <c-form layout="inline">
                <c-form-field>
                    <c-form-input placeholder="search for text" :clearable=true v-model="searchText" />
                    <c-form-select v-model="enabled" :options="selectOptions" />
                </c-form-field>
              </c-form>
            </template>
            <template slot="right">
              <c-form layout="inline">
                <c-form-field>
                  <c-form-group>
                    <a href="#" @click.prevent="onRefresh()"><i class="icon-spinner9 u-color-success" /></a>&nbsp;
                    <a href="#" @click.prevent="onNewUser()"><i class="icon-user-plus u-color-success" /></a>
                  </c-form-group>
                </c-form-field>
              </c-form>
            </template>
          </c-level>
        </div>
        <!-- END .toolbar__group -->
      </div>
    </header>
    <div class="l-container">
        <c-row >
            <c-col md>
                <c-panel>
                  <table class="table table--striped">
                    <thead>
                        <th>Name</th>
                        <th>Login</th>
                        <th>Enabled</th>
                        <th></th>
                    </thead>
                  <tbody>
                  <tr v-for="u in data" v-bind:key="u.id">
                    <td>{{u.name}}</td>
                    <td>{{u.login}}</td>
                    <td><i class="icon-checkmark2" v-if="u.enabled"/></td>
                    <td><a href="#" @click.prevent="onEditUser(u.id)"><i class="icon-pencil u-color-success" /></a></td>
                  </tr>
                  </tbody>
                  </table>
                </c-panel>
            </c-col>
        </c-row>
    </div>
  <ClientUser ref="cu"></ClientUser>
  </c-body>
</template>
<script>
import { mapState } from 'vuex'
import usersAdmin from '../../services/usersadmin.service'
import ClientUser from './User'

export default {
  name: 'ClientUsers',

  components: { ClientUser },

  computed: {
    ...mapState('auth', ['clientCode', 'clientId'])
  },

  data () {
    return {
      searchText: null,
      enabled: 'yes',
      selectOptions: [
        {value: 'yes', label: 'Enabled'},
        {value: 'no', label: 'Disabled'},
        {value: 'all', label: 'All'}
      ],
      data: [],
      lastQuery: '',
      tf: null,
      dataLoaded: false
    }
  },

  created () {
    this.refreshData()
  },

  watch: {
    searchText: function (oldText, newText) {
      this.searchForText()
    },

    enabled: function (oldValue, newValue) {
      this.searchForText()
    }
  },

  methods: {
    refreshData () {
      if (this.tf != null) { clearTimeout(this.tf) }
      this.getData()
    },

    searchForText () {
      if (this.tf != null) { clearTimeout(this.tf) }
      this.tf = setTimeout(this.refreshData, 500)
    },

    getData () {
      usersAdmin.getUsers(this.clientCode, this.searchText, this.enabled).then((response) => {
        this.handleData(response.data)
      }).catch((reason) => {
        console.error('Could not get data')
        console.error(reason)
      })
    },

    handleData (data) {
      this.data = data
      this.dataLoaded = true
    },

    onNewUser () {
      this.$refs.cu.newUser()
    },

    onRefresh () {
      this.refreshData()
    },

    onEditUser (userId) {
      this.$refs.cu.editUser(userId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ClientSettings/Users.vue